export default __webpack_public_path__ + "static/media/serviceIcon1.d49eae2b.svg";